module.exports = __webpack_public_path__ + "img/2.9524ba3c.jpg";